import React, { FC, ReactNode, ButtonHTMLAttributes } from 'react'
import classNames from 'classnames'
import styles from './Button.module.scss'

export type ButtonVariant = 'filled' | 'outlined' | 'text'
export type IconPosition = 'left' | 'right'
export type ButtonTheme = 'primary' | 'secondary' | 'tertiary' | 'support'
export type TextAlign = 'left' | 'center'
export type ButtonSize = 'default' | 'small'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label?: ReactNode
  icon?: ReactNode
  variant?: ButtonVariant
  theme?: ButtonTheme
  iconOnly?: boolean;
  disabled?: boolean
  iconPosition?: IconPosition
  className?: string;
  fullWidth?: boolean;
  textAlign?: TextAlign;
  size?: ButtonSize
}

export const Button: FC<ButtonProps> = ({
  label,
  icon,
  variant = 'filled',
  theme = 'primary',
  iconOnly = false,
  disabled = false,
  iconPosition = 'left',
  className,
  textAlign = 'center',
  fullWidth = false,
  size = 'default',
  ...props
}) => {
  return (
    <button
      className={classNames(
        styles.Button,
        styles[variant],
        styles[`${variant}--${theme}`],
        {
          [styles.Disabled]: disabled,
          [styles.IconOnlyButton]: iconOnly,
          [styles.TextButtonInline]: variant === 'text' && typeof label !== 'string',
          [styles.FullWidth]: fullWidth,
          [styles.Small]: size == 'small',
        },
        className
      )}
      disabled={disabled}
      {...props}
    >
      <div className={classNames(styles.ContentWrapper, {
        [styles.AlignLeft]: textAlign === 'left',
        [styles.AlightCenter]: textAlign === 'center',
        [styles.ContentSmall]: size === 'small',
      })}>
        {icon && iconPosition === 'left' && <span className={styles.Icon}>{icon}</span>}
        {label && !iconOnly && <span className={styles.Label}>{label}</span>}
        {icon && iconPosition === 'right' && <span className={styles.Icon}>{icon}</span>}
      </div>
    </button >
  )
}
